// Holds the active catalog in module state so t() can stay synchronous. The
// German dictionary is dynamically imported so it lands in its own chunk and
// never ships inside the English bundle.
import { DEFAULT_LOCALE } from './locale';

let activeLocale = DEFAULT_LOCALE;
let activeDict = {};
let version = 0;

export function setCatalog(locale, dict) {
  activeLocale = locale;
  activeDict = dict || {};
  version += 1;
}

export function getCatalogLocale() {
  return activeLocale;
}

export function getCatalogVersion() {
  return version;
}

export function lookup(englishText) {
  const entry = activeDict[englishText];
  return entry && typeof entry.de === 'string' && entry.de ? entry.de : undefined;
}

// A dynamic import can stall indefinitely rather than reject (e.g. a hung
// connection). Render is gated on this promise, so an unsettled promise means a
// permanent blank page. Race a timeout so the catalog ALWAYS settles and the
// worst case degrades to English rather than to nothing.
const CATALOG_LOAD_TIMEOUT_MS = 5000;

export async function loadCatalog(locale) {
  if (locale === DEFAULT_LOCALE) {
    setCatalog(DEFAULT_LOCALE, {});
    return;
  }
  try {
    const mod = await Promise.race([
      import(/* webpackChunkName: "locale-de" */ './locales/de.json'),
      new Promise((_resolve, reject) => {
        setTimeout(
          () => reject(new Error(`[i18n] catalog load timed out after ${CATALOG_LOAD_TIMEOUT_MS}ms`)),
          CATALOG_LOAD_TIMEOUT_MS
        );
      }),
    ]);
    setCatalog(locale, mod.default || mod);
  } catch (err) {
    // A missing, malformed, or slow catalog must degrade to English, never to a
    // blank page. The site is still fully usable in this state.
    console.error(`[i18n] failed to load catalog for "${locale}", falling back to English`, err);
    setCatalog(DEFAULT_LOCALE, {});
  }
}
